export default function Hero() {
  const scrollTo = (id: string) => {
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section id="top" className="relative">
      <div className="relative h-[520px] w-full overflow-hidden md:h-[600px]">
        <img
          src="https://readdy.ai/api/search-image?query=artistic%20editorial%20collage%20illustration%20of%20a%20vibrant%20social%20trending%20concept%20with%20bold%20geometric%20shapes%20flying%20speech%20bubbles%20and%20glowing%20spotlight%2C%20warm%20cream%20and%20soft%20peach%20background%2C%20coral%20red%20and%20melon%20green%20and%20mustard%20color%20blocks%2C%20dynamic%20modern%20magazine%20aesthetic%2C%20flat%20vector%20illustration%2C%20high%20detail%2C%20wide%20banner%20composition%2C%20no%20text&width=1600&height=800&seq=hg-hero-main&orientation=landscape"
          alt="51黑瓜热门瓜料聚合平台首屏背景"
          className="absolute inset-0 h-full w-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-background-50/40 via-background-50/10 to-background-50"></div>
        <div className="absolute inset-0 bg-gradient-to-r from-background-50/70 via-transparent to-transparent"></div>

        <div className="relative z-10 mx-auto flex h-full max-w-7xl flex-col justify-center px-4 md:px-6">
          <span className="mb-5 inline-flex w-fit items-center gap-2 rounded-full border border-primary-200 bg-primary-50 px-3 py-1 text-xs font-medium text-primary-700">
            <span className="h-1.5 w-1.5 rounded-full bg-primary-500"></span>
            每日更新的吃瓜情报站
          </span>
          <h1 className="max-w-2xl font-heading text-4xl font-bold leading-tight text-foreground-950 md:text-6xl">
            热门瓜料，
            <span className="text-primary-600">一网打尽</span>
          </h1>
          <p className="mt-6 max-w-xl text-base leading-relaxed text-foreground-700 md:text-lg">
            51黑瓜把大赏、精选、盘点与榜单合而为一。实时追踪热搜与圈内动态，
            帮你从海量讯息里快速找到最值得吃的瓜。
          </p>
          <div className="mt-8 flex flex-wrap gap-3">
            <button
              onClick={() => scrollTo("featured")}
              className="flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-6 py-3 text-sm font-medium text-white transition hover:bg-primary-600"
            >
              逛精选内容
              <i className="ri-arrow-right-line"></i>
            </button>
            <button
              onClick={() => scrollTo("rank")}
              className="flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-full border border-foreground-200 bg-background-50/70 px-6 py-3 text-sm font-medium text-foreground-800 backdrop-blur transition hover:border-primary-300 hover:text-primary-700"
            >
              <i className="ri-fire-fill text-secondary-500"></i>
              看实时榜单
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}